"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KNOWN_ERRORS = void 0;
var _errors = _interopRequireDefault(require("../consts/errors"));
const KNOWN_ERRORS = {
  "User is not verified.": {
    code: "NOT_VERIFIED",
    message: _errors.default.notVerified
  },
  "Login failed.": {
    code: "INVALID_LOGIN",
    message: _errors.default.loginFailed
  },
  "You are temporarily blocked from other login attempts.": {
    code: "BLOCKED_TEMPORARILY",
    message: _errors.default.blockedTemporarily
  }
};
exports.KNOWN_ERRORS = KNOWN_ERRORS;